import { jsxs as z, Fragment as H, jsx as u } from "react/jsx-runtime";
import { c as N } from "react/compiler-runtime";
import { Stack as V, Typography as M, Select as $, Pagination as q, TablePagination as G, Box as J, MenuItem as Q, PaginationItem as U } from "@mui/material";
import { u as W } from "../../../chunks/TableContext.js";
import { PaginationActions as X } from "./PaginationActions.js";
import { styles as g } from "./styles.js";
import { useRef as Y, useEffect as Z } from "react";
import ee from "@mui/icons-material/KeyboardDoubleArrowLeft";
import te from "@mui/icons-material/KeyboardDoubleArrowRight";
import oe from "@mui/icons-material/KeyboardArrowLeft";
import ne from "@mui/icons-material/KeyboardArrowRight";
function be() {
  const e = N(45), {
    table: s,
    data: o,
    enableVirtualization: l,
    pageSize: B,
    setPageSize: R,
    currentPage: F,
    setCurrentPage: b,
    hideRowsPerPageSelector: O,
    disablePagination: j,
    rowsPerPageOptions: C,
    isManualPagination: n,
    onPaginationChange: L,
    onRowsPerPageChange: A,
    totalPages: x,
    currentRowsPerPage: P,
    footerLeftComponent: p
  } = W(), t = B === void 0 ? 10 : B;
  let v;
  e[0] !== R ? (v = R === void 0 ? le : R, e[0] = R, e[1] = v) : v = e[1];
  const D = v, a = F === void 0 ? 0 : F;
  let S;
  e[2] !== b ? (S = b === void 0 ? se : b, e[2] = b, e[3] = S) : S = e[3];
  const r = S, E = O === void 0 ? !1 : O, i = j === void 0 ? !1 : j;
  let y;
  e[4] !== C ? (y = C === void 0 ? [] : C, e[4] = C, e[5] = y) : y = e[5];
  const h = y, k = Y(o.length);
  let _;
  e[6] !== a || e[7] !== o.length || e[8] !== i || e[9] !== l || e[10] !== n || e[11] !== t || e[12] !== r || e[13] !== s ? (_ = () => {
    if (n || l)
      return;
    if (k.current !== o.length) {
      k.current = o.length;
      const c = Math.ceil(s.getRowCount() / t);
      !i && c > 0 && a >= c && r(c - 1);
    }
  }, e[6] = a, e[7] = o.length, e[8] = i, e[9] = l, e[10] = n, e[11] = t, e[12] = r, e[13] = s, e[14] = _) : _ = e[14];
  let I;
  if (e[15] !== o.length || e[16] !== i || e[17] !== l || e[18] !== n || e[19] !== t || e[20] !== r ? (I = [t, r, i, n, l, o.length], e[15] = o.length, e[16] = i, e[17] = l, e[18] = n, e[19] = t, e[20] = r, e[21] = I) : I = e[21], Z(_, I), i || l)
    return null;
  const K = n ? x : Math.ceil(s.getRowCount() / t), w = E || h.length === 0;
  let f;
  e[22] !== a || e[23] !== P || e[24] !== p || e[25] !== t || e[26] !== x ? (f = p && (typeof p == "function" ? p({
    pageSize: t ?? 0,
    currentPage: a ?? 0,
    totalPages: x ?? 0,
    currentRowsPerPage: P ?? 0
  }) : p), e[22] = a, e[23] = P, e[24] = p, e[25] = t, e[26] = x, e[27] = f) : f = e[27];
  let m;
  e[28] !== K || e[29] !== a || e[30] !== P || e[31] !== i || e[32] !== n || e[33] !== L || e[34] !== A || e[35] !== t || e[36] !== h || e[37] !== r || e[38] !== D || e[39] !== w || e[40] !== s ? (m = !i && (n ? /* @__PURE__ */ z(V, { sx: g.rowsPerPageStack, children: [
    !w && /* @__PURE__ */ z(H, { children: [
      /* @__PURE__ */ u(M, { sx: g.rowsPerPageText, children: "Rows per page:" }),
      /* @__PURE__ */ u($, { sx: g.rowsPerPageSelect, variant: "outlined", value: P || 10, onChange: (d) => {
        A?.(Number(d.target.value));
      }, children: h?.map(ie) })
    ] }),
    /* @__PURE__ */ u(q, { count: K, page: a, sx: g.paginationStyle, onChange: (d, c) => L?.(c), size: "small", shape: "rounded", variant: "outlined", showFirstButton: !0, showLastButton: !0, siblingCount: 1, boundaryCount: 1, renderItem: re })
  ] }) : /* @__PURE__ */ u(G, { component: "div", count: s.getRowCount(), page: a, onPageChange: (d, c) => r(c), rowsPerPage: t, onRowsPerPageChange: (d) => {
    D(parseInt(d.target.value, 10)), r(0);
  }, rowsPerPageOptions: w ? [] : h, ActionsComponent: X, sx: g.tablePagination, labelDisplayedRows: ae, labelRowsPerPage: w ? null : /* @__PURE__ */ u(M, { component: "span", sx: g.paginationRowsPerPageText, children: "Rows per page:" }) })), e[28] = K, e[29] = a, e[30] = P, e[31] = i, e[32] = n, e[33] = L, e[34] = A, e[35] = t, e[36] = h, e[37] = r, e[38] = D, e[39] = w, e[40] = s, e[41] = m) : m = e[41];
  let T;
  return e[42] !== f || e[43] !== m ? (T = /* @__PURE__ */ z(J, { sx: g.paginationContainer, children: [
    f,
    m
  ] }), e[42] = f, e[43] = m, e[44] = T) : T = e[44], T;
}
function ae(e) {
  const {
    from: s,
    to: o,
    count: l
  } = e;
  return /* @__PURE__ */ z(M, { component: "span", sx: g.paginationText, children: [
    "Rows: ",
    s,
    "–",
    o,
    " of ",
    l
  ] });
}
function re(e) {
  return /* @__PURE__ */ u(U, { slots: {
    first: ee,
    last: te,
    previous: oe,
    next: ne
  }, ...e });
}
function ie(e) {
  return /* @__PURE__ */ u(Q, { value: e, children: e }, e);
}
function se() {
}
function le() {
}
export {
  be as TableFooter
};
